import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import Input from 'components/Input';
import ArrayGroup from './ArrayGroup';
import {
  isRequired,
  makeIntegerRangeValidator
} from 'utilities/validators.js';


export const minGroups = 3;
export const maxGroups = 25;

const isIntegerRange = makeIntegerRangeValidator(minGroups, maxGroups);

const SummaryStatistics = ({ isSummaryDataTab, numberOfGroups }) =>
  <>
    <Field
      type="number"
      id="numbersOfGroups"
      component={Input}
      name="numbersOfGroups"
      label="Numbers of Groups:"
      pattern="\d+"
      min={minGroups}
      max={maxGroups}
      validate={[isRequired, isIntegerRange]}
      wrapperClassName="relative flex baseline iconTop pt-10 mb-10"
      inputClassName="width-70 ml-10 main-input__input"
      iClassName="icon icon-alert-triangle t-10"
      disabled={!isSummaryDataTab}
    />
    <FieldArray
      name="groups"
      component={ArrayGroup}
      numberOfGroups={numberOfGroups}
      isSummaryDataTab={isSummaryDataTab}
    />
  </>;


SummaryStatistics.propTypes = {
  numberOfGroups: PropTypes.string,
  isSummaryDataTab: PropTypes.bool.isRequired
};

export default SummaryStatistics;
